import React from "react";
import { Grid, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ProductCard from "../Products/ProductCard";
import { getWord } from "../../utils/functions";
import { isDesktop } from "react-device-detect";

const Trending = (props) => {
  return (
    <section className="flat-spacing-6">
      <div className="container">
        <div className="flat-title wow fadeInUp" data-wow-delay="0s">
          <span className="title">{getWord("Trending Products")}</span>
          <p
            className="sub-title text_black-2 wow fadeInUp"
            data-wow-delay="0s"
            style={{
              visibility: "visible",
              animationDelay: "0s",
              animationName: "fadeInUp",
            }}
          >
            {getWord(
              "Check out our trending now section for the latest must-haves"
            )}
          </p>
        </div>
        <div className="hover-sw-nav hover-sw-2">
          <Swiper
            slidesPerView={isDesktop ? 4 : 2}
            grid={{
              rows: 1,
            }}
            spaceBetween={30}
            navigation={true}
            modules={[Grid, Navigation]}
            className="swiper tf-sw-product-sell wrap-sw-over"
          >
            {props.data.map((prod, index) => (
              <SwiperSlide key={index}>
                <ProductCard {...prod} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Trending;
